import { servicesSettingsToggle } from "../../screens/Services/data/actions";
import { settingsToggle as servicecentersSettingsToggle } from "../../screens/ServiceCenters/data/actions";
import appUrls from "../../config/appUrls";
import { TOGGLE_BODY_SCROLL, TOGGLE_LOADING } from "./constants";

export const handleSettingsClick = () => (dispatch, getState) => {
  const { pathname } = getState().router.location;
  switch (pathname) {
    case appUrls.SERVICES:
      dispatch(servicesSettingsToggle());
      break;
    case appUrls.SERVICE_CENTERS:
      dispatch(servicecentersSettingsToggle());
      break;

    default:
      return;
  }
};

export const toggleScroll = value => {
  return {
    type: TOGGLE_BODY_SCROLL,
    payload: value
  };
};

export const toggleLoading = () => {
  return {
    type: TOGGLE_LOADING
  };
};
